export const parseTimeToDisplayFormat = (value: number): string => {
  // ensure value is not negative
  const safeValue = Math.max(0, value);
  return safeValue < 10 ? `0${safeValue}` : `${safeValue}`;
};

export const formatTimeforCallTimer = (totalSeconds: number): string => {
  const safeTotalSeconds = Math.max(0, totalSeconds);
  const hours = Math.floor(safeTotalSeconds / 3600);
  const remainingSeconds = safeTotalSeconds % 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  const formattedHours = parseTimeToDisplayFormat(hours);
  const formattedMinutes = parseTimeToDisplayFormat(minutes);
  const formattedSeconds = parseTimeToDisplayFormat(seconds);

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};
